import { createContext } from 'react';

import { CountryRiskLevelType } from 'api/types/entity';

import { CountryRiskRole } from './types';

export interface CountryRiskContextProps {
  role: CountryRiskRole;
  countryRiskLevels?: Map<string, CountryRiskLevelType | undefined>;
}

export const CountryRiskContext = createContext<CountryRiskContextProps | null>(
  null
);
